export default "/fonts/vendor/primeicons/primeicons.svg?c55d94a248721abbd2205460c2ca9cea";